import OnlyTabs from "@metacrm/metacrm-material-ui/dist/OnlyTabs";
import { Box } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import WidgetPreview from "./Preview/WidgetPreview";
import DiscordPreview from "./Preview/DiscordPreview";
import NotificationDetailContext from "features/metadesk/Notification/NotificationDetail/NotificationDetail.context";
import {
  selectWidgetConnected,
  selectXMTPConnected,
} from "features/metadesk/redux/entityConfig/entityConfig.selector";
import XmtpPreview from "./Preview/XmtpPreview";
import EmailPreview from "./Preview/EmailPreview";
import { useSelector } from "react-redux";
import TelegramPreview from "./Preview/TelegramPreview";
import { useIntl } from "react-intl";
import { selectRemindBarShow } from "features/metadesk/redux/globalState/globalState.selector";

const NotificationPreview = () => {
  const { formatMessage } = useIntl();
  const widgetConnected = useSelector(selectWidgetConnected);
  const xmtpConnected = useSelector(selectXMTPConnected);

  const { formData } = useContext(NotificationDetailContext);
  const { channels } = formData;
  const isWidgetDisabled = !channels.widget || !widgetConnected;
  const isXMTPDisabled = !channels.xmtp || !xmtpConnected;

  const tabsArray = [
    {
      label: formatMessage({ id: "campaignPerformance.tab.widget.title" }),
      disabled: isWidgetDisabled,
    },
    {
      label: formatMessage({ id: "global.commonWord.discord" }),
      disabled: !channels.discord,
    },
    {
      label: formatMessage({ id: "global.commonWord.telegram" }),
      disabled: !channels.telegram,
    },
    {
      label: formatMessage({ id: "global.form.email.label" }),
      disabled: !channels.email,
    },
    {
      label: formatMessage({ id: "integration.xmtp.name" }),
      disabled: isXMTPDisabled,
    },
  ];

  const [value, setValue] = useState(-1);

  useEffect(() => {
    const hasChannels = tabsArray.findIndex((tab) => !tab.disabled);
    setValue(hasChannels);
  }, [channels]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const remindBarShow = useSelector(selectRemindBarShow);

  const renderPreview = [
    <WidgetPreview formData={formData} disabled={isWidgetDisabled} />,
    <DiscordPreview formData={formData} disabled={!channels.discord} />,
    <TelegramPreview formData={formData} disabled={!channels.telegram} />,
    <EmailPreview formData={formData} disabled={!channels.email} />,
    <XmtpPreview formData={formData} disabled={isXMTPDisabled} />,
  ];

  return (
    <Box sx={{ position: "sticky", top: remindBarShow ? 50 : 10 }}>
      <Box bgcolor="white" borderRadius="4px" overflow="hidden">
        <Box p="15.5px 12px" borderBottom="1px solid #E6E6E6">
          {formatMessage({ id: "global.function.preview" })}
        </Box>
        <Box px="8px">
          <OnlyTabs tabs={tabsArray} value={value} onChange={handleChange} />
        </Box>
        {value !== -1 ? (
          renderPreview[value]
        ) : (
          <Box
            className="item-flex"
            sx={{
              borderRadius: "0 0 4px 4px",
              width: "100%",
              height: "639px",
              bgcolor: "#EDEDED",
              justifyContent: "center",
              color: "#555",
            }}
          >
            {formatMessage({ id: "notification.preview.selectChannelsError" })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NotificationPreview;
